import React from 'react'
import { IIconProps } from '../types/types'

const Trash: React.FC<IIconProps> = (props) => {
  return (
    <>
      <svg
        className={props.className}
        xmlns='http://www.w3.org/2000/svg'
        height={props.width ? props.width : '24px'}
        width={props.width ? props.width : '24px'}
        fill={props.color ? props.color : '#646464'}
        viewBox='0 0 24 24'
      >
        <path d='M0 0h24v24H0z' fill='none' />
        <path d='M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z' />
      </svg>
    </>
  )
}

export default Trash
